import React from 'react';

import FlatButton from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';

import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledH3 = styled.h3`
  text-align: center;
`;

export const BamboraPaymentConfirmation = ({
  paymentWithFee,
  sendingPayment,
  toggleConfirmationDialog,
  finalizePayment,
}) => {
  return (
    <React.Fragment>
      <StyledH3>{getTranslatedString('bamboraCheckout.confirmPaymentDetails')}</StyledH3>
      <DialogContent>
        <div className="row" style={{ padding: '4px 0' }}>
          <div className="col-xs-6" style={{ textAlign: 'right' }}>
            {getTranslatedString('bamboraCheckout.paymentAmount')}
          </div>
          <div className="col-xs-6" style={{ textAlign: 'left' }}>
            {`${paymentWithFee.formattedAmount}`}
          </div>
        </div>
        <div className="row" style={{ padding: '4px 0' }}>
          <div className="col-xs-6" style={{ textAlign: 'right' }}>
            {getTranslatedString('bamboraCheckout.fee')}
          </div>
          <div className="col-xs-6" style={{ textAlign: 'left' }}>
            {paymentWithFee.formattedFee}
          </div>
        </div>
        <div className="row" style={{ padding: '4px 0' }}>
          <div className="col-xs-6" style={{ textAlign: 'right' }}>
            <strong>{getTranslatedString('bamboraCheckout.totalAmountDue')}</strong>
          </div>
          <div className="col-xs-6" style={{ textAlign: 'left' }}>
            <strong>{paymentWithFee.formattedTotal}</strong>
          </div>
        </div>
      </DialogContent>
      <div className="row">
        <div
          className="col-xs-12"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 8,
          }}
        >
          <FlatButton
            variant="contained"
            disabled={sendingPayment}
            onClick={toggleConfirmationDialog}
            style={{ color: AccentColor(), backgroundColor: '#fff' }}
          >
            {getTranslatedString('bamboraCheckout.cancelPayment')}
          </FlatButton>
          <FlatButton
            variant="contained"
            disabled={sendingPayment}
            onClick={finalizePayment}
            style={{
              color: 'white',
              backgroundColor: sendingPayment ? colors.LIGHT_GRAY : AccentColor(),
            }}
          >
            {getTranslatedString('bamboraCheckout.confirmPayment', {
              totalAmount: paymentWithFee.formattedTotal,
            })}
          </FlatButton>
        </div>
      </div>
    </React.Fragment>
  );
};
